import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { isEmpty } from 'ramda';

import { getSelectionURI } from 'utils/helpers/url';
import getIndexOfSelector from './helpers';

const useSetSelectorIndex = (list, setFilters, prop = 'nameShort') => {
  const { viewById } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isEmpty(list)) {
      // check if pathname contains a viewById (product/location)
      // if viewById, push to url then set selected index/id
      // else the first should already be selected but push name into url
      if (viewById) {
        setFilters({ name: 'selectedIndex', value: getIndexOfSelector(viewById, list, prop) });
      } else {
        const encoded = getSelectionURI(list[0]);
        setFilters({ name: 'selectedIndex', value: 0 });
        // trim trailing / if it exists causing issues
        navigate(`${pathname.replace(/\/$/, '')}/${encoded}`, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);
};

export default useSetSelectorIndex;
